
<div class="conversationLogs">
  <div class="sectionHeader">
    <span>Conversation log</span>
  </div>
  <div class="is-loading" *ngIf="isLoading"> LOADING... </div>
  <div class="logsList">
   
    <div *ngFor=" let item of converstation; let i = index;">
   
    <div>

    <!-- Assistant Message -->
      <div *ngIf="item.type =='outgoing'"  class="messageBubble" style="width: 50%;">
        <div class="messageBody">
          <div class="bubbleHeader" *ngIf="(item.type != (i==0?converstation[i].type:converstation[i-1].type))">
            <div class="messageIcon">
              <img [src]="messageIcon" alt="Assistant" />
            </div>
            <div class="messageType"> Assistant</div>
            <div 
              class="messageAction"
              (click)="GetConversation(item, i)"
            >
              <span class="dotsIcon"><img [src]="(item.comment_count > 0?dotsHIcon:dotsIcon)" alt="Edit" /></span>
              <span class="editIcon" [ngClass]="item.comment_count > 0 ? ' hide' : ''"><img [src]="(item.comment_count > 0?editHIcon:editIcon)" alt="Edit" /></span>
              <span class="commented-icon" *ngIf="item.comment_count > 0">Reviewed</span>
            </div>
          </div>
          <div class="bubbleBody">
            <div class="boxBg"></div>
            <div class="messageBox" *ngIf="(item.text != 'null' && item.text != false)">
              <p [innerHTML]="item.text"></p>
              <p class="msg-date-time">{{item.timestamp | date:'medium'}}</p>
            </div>
          </div>

          <div class="bubbleBody">
            <div class="messageBox3" *ngIf="item.quick_replies != null && item.quick_replies.length != 0">
              <div class="quickReplyBox" *ngFor="let sQp of item.quick_replies"> 
                {{ sQp }}
              </div>
            </div>
          </div>  
          
          <div class="bubbleBody">
            <ul class="messageBox2" *ngIf="item.search_documents != null && item.search_documents.length != 0">
              <div class="boxBg"></div>
              <li class="rowLi" *ngFor="let sDocs of item.search_documents"> 
                <div>{{sDocs.title}}</div> <span  class="sourceArrow"> <a href={{sDocs.url}} target="_blank"> > </a> </span>
                <br/>  
              </li>
            </ul>
          </div>
        </div>
      </div>
      
      <!-- user Message -->
      <div *ngIf="item.type =='incoming'" class="messageBubble userBubble rightAlign">
        <div class="messageBody rightFloat">
          <div class="bubbleHeader">
          <div class="messageIcon">
            <img [src]="ovalImagePath" alt="User" />
          </div>
          <div class="messageType"></div>
          <div class="messageAction" (click)="GetConversation(item, i)">
            <span class="dotsIcon"><img [src]="(item.comment_count > 0?dotsHIcon:dotsIcon)" alt="Edit" /></span>
            <span class="editIcon" [ngClass]="item.comment_count > 0 ? ' hide' : ''"><img [src]="(item.comment_count > 0?editHIcon:editIcon)" alt="Edit" /></span>
            <span class="commented-icon" *ngIf="item.comment_count > 0">Reviewed</span>
          </div>
          </div>
        <div class="bubbleBody">
          <div class="boxBg"></div>
          <div class="messageBox">
            <p *ngIf="(item.text != null)">{{item.text}}</p>
            <p *ngIf="(item.quick_reply != null)">{{item.quick_reply}}</p>
            <!-- <p *ngIf="(item.message_type == 'prediction'  && (item.prediction?.concepts[0]?.concept_label == 'Experience Rating'))" >
                {{ item.prediction.concepts[0].concept_label }}
              <img [src]="ratingImagePath1" class="ratingimg" *ngIf="(item.prediction.concepts[0].concept_value == '0')" />
              <img [src]="ratingImagePath2" class="ratingimg" *ngIf="(item.prediction.concepts[0].concept_value == '1')" />
              <img [src]="ratingImagePath3" class="ratingimg" *ngIf="(item.prediction.concepts[0].concept_value == '2')" />
              <img [src]="ratingImagePath4" class="ratingimg" *ngIf="(item.prediction.concepts[0].concept_value == '4')" />
              <img [src]="ratingImagePath5" class="ratingimg" *ngIf="(item.prediction.concepts[0].concept_value == '5')" />
            </p> -->
            <p class="msg-date-time">{{item.timestamp | date:'medium'}}</p>
          </div>
          
        </div>
        </div>
      </div>
    </div>

      <!-- feed back form -->
      <form [formGroup]="profileForm">
        <div
          class="webForm"
          ng-class="{'bg-success':class_status }"
          *ngIf="(this.msgId == item.id) && (this.converStationType == item.type)"
          [ngStyle]="{ 'margin-left' : this.converStationType == 'outgoing'? '0%': '50%'}"
          >
            <!-- <h2>Would you like to add a comment or add a training sample to an existing skill?</h2> -->
            
            <!-- <div class="formGroup" *ngIf="(converStationType == 'incoming')">
              <mat-radio-group (change)="handleChange($event)" aria-label="Select an option" formControlName="optionValue">
                <mat-radio-button value="yes"> Yes </mat-radio-button>
                <mat-radio-button value="no"> No </mat-radio-button>
              </mat-radio-group>
            </div> -->

            <div class="formGroup" *ngIf="converStationType == 'incoming'">
              <!-- <label>Select intent</label> -->
              <!-- <select (change)="onChangeObj($event.target.value)">
                <option selected="selected" disabled [value]=""> Choose Intent </option>
                <option *ngFor="let intent of intentSkills" [value]="intent.id">{{intent.intent}}</option>
              </select> -->

              <mat-form-field style="width: 100%;">
                <mat-select placeholder="Choose skills" formControlName="selectedIntent">
                  <mat-select-filter [placeholder]="'Search Skills'" [displayMember]="'intent'" [array]="intentSkills" (filteredReturn)="getFilteredValues($event)"></mat-select-filter>
                  <mat-option *ngIf="profileForm.value.selectedIntent">Clear Selection</mat-option>
                  <mat-option *ngFor="let item of intentSkills" [(value)]="item.intent">
                    {{item.intent}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              
            </div>
            
            <!-- <div class="formGroup" *ngIf="(converStationType == 'incoming' && profileForm.value.selectedIntent != '' && profileForm.value.optionValue == 'yes')">
              <label>Response</label>
              <span *ngFor="let item of intentSkills"> <textarea *ngIf="(item.id == profileForm.value.selectedIntent)" disabled> {{item.Response}} </textarea> </span>
            </div> -->

            <div class="formGroup" *ngIf="(converStationType == 'incoming' && profileForm.value.selectedIntent != '')">
              <label> Training phrase </label>
              <textarea formControlName="converstationMsg"> {{ profileForm.value.converstationMsg }} </textarea>
            </div>

            <div class="formGroup">
              <label>Comment</label>
              <textarea formControlName="converstationComment"> </textarea>
            </div>

            <div class="formActions">
              <button class="cancelBtn" (click)="ClearDialog()">Cancel</button>
              <button (click)="AddFeedbackConversation()">Submit</button>
            </div>
        </div>  
       </form>

    </div>
    
    <div *ngIf="isCompleteFeedbackEnabled" class="topActions">
      <button mat-button mat-raised-button color="primary" (click)="CompleteFeedback()">Complete Feedback</button>
    </div>

  </div>
</div>